module.exports = "<button class=\"btn btn-addon btn-lg col-sm-8\" [ngClass]=\"statusClass\">\n  <i [ngClass]=\"statusSymbolClass\"></i>{{statusText}} - {{callTime | hms}}\n</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/call-status-box/call-status-box.component.html
// module id = ../../../../../src/app/call-status-box/call-status-box.component.html
// module chunks = main